/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'util/PropTypes';
import { Label } from 'ca-ui-toolkit';
import { ToolbarItem, CaretToolbarItem } from 'components/toolbar/items';
import StringResources from 'nls/StringResources';

import './navigation.scss';

@observer
class Navigation extends Component {

	constructor(props) {
		super(props);
	}

	render() {
		const label = this.renderLabel(this.props.index, this.props.count);

		return (
			<div className="explore-card-navigation">
				<CaretToolbarItem
					arrow="up"
					title={StringResources.get('card_navigation_previous')}
					enabled={this.canNavigatePrevious()}
					onPrimaryAction={() => this.onNavigateLeftClick()}
				/>
				<ToolbarItem>
					{label}
				</ToolbarItem>
				<CaretToolbarItem
					arrow="down"
					title={StringResources.get('card_navigation_next')}
					enabled={this.canNavigateNext()}
					onPrimaryAction={() => this.onNavigateRightClick()}
				/>
			</div>
		);
	}

	renderLabel(index, count) {
		if (index >= count) {
			// throw new Error(`Out of bounds. Guarding condition failed: 'props.index < props.count'. ${index} >= ${count}`);
			return;
		}
		if (count > 0 && index < 0) {
			// throw new Error(`Out of bounds. Guarding condition failed: 'props.index >= 0'. ${index} < 0`);
			return;
		}

		let label;
		if (count > 0) {
			label = `${index + 1}/${count}`;
		} else {
			label = `${count}`;
		}
		return <Label label={label} />;
	}

	isEmpty() {
		return this.props.count <= 0;
	}

	canNavigatePrevious() {
		return !this.isEmpty() && this.props.index > 0;
	}

	canNavigateNext() {
		return !this.isEmpty() && this.props.index < this.props.count - 1;
	}

	onNavigateLeftClick() {
		this.props.onNavigatePrevious();
	}

	onNavigateRightClick() {
		this.props.onNavigateNext();
	}

}

Navigation.propTypes = {
	index: PropTypes.number,
	count: PropTypes.number,
	onNavigatePrevious: PropTypes.func.isRequired,
	onNavigateNext: PropTypes.func.isRequired
};

Navigation.defaultProps = {
	index: 0,
	count: 0,
	onNavigatePrevious: () => {},
	onNavigateNext: () => {}
};

export default Navigation;



// WEBPACK FOOTER //
// ./src/js/components/toolbar/navigation/Navigation.js